import { memo } from "react";
import SearchSelect from "../../../../GlobalComponents/FormComponents/Dropdowns/SearchSelect";

/**
 * Several values from a fixed list, picked in the cell — industries,
 * frameworks. The trigger says how many are picked, so the row stays one line.
 *
 * @param {object} props
 * @param {string[]} props.value
 * @param {{ value: string, label: string }[]} props.options
 * @param {boolean} [props.dirty]
 * @param {boolean} [props.invalid] outlines the cell as needing fixing
 * @param {boolean} [props.disabled]
 * @param {string} props.ariaLabel
 * @param {string} [props.allLabel] the select-all row, and the label when nothing or everything is picked, e.g. "All industries"
 * @param {string} [props.placeholder] shown when nothing is picked, for lists with no select-all row
 * @param {string} [props.title] tooltip on the trigger
 * @param {string} props.noun plural for the count, e.g. "industries"
 * @param {(value: string[]) => void} props.onChange
 */
function MultiPickCell({ value, options, dirty, invalid, disabled, ariaLabel, allLabel, placeholder, title, noun, onChange }) {
  return (
    <div className={`kgb-tagvalue${dirty ? " kgb-tagvalue--dirty" : ""}${invalid ? " kgb-tagvalue--invalid" : ""}`}>
      <SearchSelect
        variant="cell"
        options={options}
        value={value}
        allLabel={allLabel}
        placeholder={placeholder}
        title={title}
        noun={noun}
        ariaLabel={ariaLabel}
        disabled={disabled}
        onChange={onChange}
      />
    </div>
  );
}

export default memo(MultiPickCell);
